const QUADS: { q: number; label: string; teeth: number[] }[] = [
  { q: 1, label: "Oberkiefer rechts (1)", teeth: [18, 17, 16, 15, 14, 13, 12, 11] },
  { q: 2, label: "Oberkiefer links (2)", teeth: [21, 22, 23, 24, 25, 26, 27, 28] },
  { q: 4, label: "Unterkiefer rechts (4)", teeth: [48, 47, 46, 45, 44, 43, 42, 41] },
  { q: 3, label: "Unterkiefer links (3)", teeth: [31, 32, 33, 34, 35, 36, 37, 38] },
];

export function ToothChart({ value, onChange, readOnly }: { value: number[]; onChange?: (v: number[]) => void; readOnly?: boolean }) {
  const toggle = (t: number) => {
    if (readOnly || !onChange) return;
    onChange(value.includes(t) ? value.filter((x) => x !== t) : [...value, t].sort());
  };
  return (
    <div data-testid="tooth-chart" className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {QUADS.map(({ q, label, teeth }) => (
        <fieldset key={q} className={`rounded-lg border border-border p-2 ${q <= 2 ? "" : "sm:mt-1"}`}>
          <legend className="px-1 text-sm text-text-muted">{label}</legend>
          <div className="grid grid-cols-8 gap-1">
            {teeth.map((t) => {
              const on = value.includes(t);
              return (
                <button
                  type="button"
                  key={t}
                  data-testid={`tooth-${t}`}
                  aria-pressed={on}
                  aria-label={`Zahn ${t}`}
                  disabled={readOnly}
                  onClick={() => toggle(t)}
                  className={`min-h-[44px] rounded-md border text-sm font-medium transition-[background-color,color] duration-150 ${
                    on ? "border-primary bg-primary text-white" : "border-border bg-surface text-text"
                  } ${readOnly ? "cursor-default" : "hover:border-primary"}`}
                >
                  {t}
                </button>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
